import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomerServiceAppService {

  constructor() { }


  getWhatsAppLink(number: string) {
    return 'https://wa.me/' + number;
}

  getTelegramLink(number: string) {
      return number?'https://t.me/' + number: null;
  }

  getCallLink(number: string) {
      return 'tel:' + number;
  }

}
